// extracted by mini-css-extract-plugin
export default {"header":"CommonBasicHeader_header__X0hZL","headerTitle":"CommonBasicHeader_headerTitle__v9pA2"};